"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SortDescendingSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var SortDescendingSVG = function SortDescendingSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("path", {
    stroke: "none",
    d: "M3 11h14a1 1 0 000-2H3a1 1 0 000 2zM11 15H3a1 1 0 000 2h8a1 1 0 000-2zM7 21H3a1 1 0 000 2h4a1 1 0 000-2zM29.7 21.2a1 1 0 00-1.5 0L23 26.5V3a1 1 0 10-2 0v23.5l-5.2-5.3a1 1 0 00-1.5 0 1 1 0 000 1.5l6.9 7a1 1 0 00.8.3 1.1 1.1 0 00.8-.3l6.9-7a1 1 0 000-1.5z"
  }));
};
exports.SortDescendingSVG = SortDescendingSVG;
SortDescendingSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(SortDescendingSVG);
exports.default = _default;